import templateUrl from "emun.filemanager/folder-prompt.htm";
import angular from "angular";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from 'servicestack/basic.controller.properties'

class controller {
constructor($scope, options) {
	const $ctrl = this;
    basicController($ctrl);
	$ctrl.bus = new ServiceBus();
	$ctrl.title = $ctrl.options.folderId ? "Edit Folder..." : "New Folder...";
	$ctrl.request = {
		folderId: $ctrl.options.folderId || "",
		folderName: $ctrl.options.folderName || "",
		parentFolder: $ctrl.options.parentFolder || ""
	};
}
save() {
	let $ctrl = this;
	$ctrl.bus.send($ctrl.options.folderId ? "UpdateDocumentFolder" : "CreateDocumentFolder", $ctrl.request).then(function(response) {
		$ctrl.$broadcast("$folderCreated");
		$ctrl.$dismiss();
	});
}

}
export default {
  open(options) {
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options
          },
          bindToController: true,
          controller,
		  controllerAs: "$ctrl",
		  size: 'lg'
        },
        (options || {}).modal
      )
    ).result;
  }
};
